export const tagsAssetsUrl: string = '../../../../../assets/deployment-icons';
